module.exports = __webpack_public_path__ + "img/not-collection.d47091b0.png";